const SUBSET_TYPE_TO_NAME_MAP: Record<string, string> = {
  fc: 'Forecast',
  an: 'Analysis',
  wp: 'Weather parameters',
  tf: 'Trajectory forecast',
  ssd: 'Simulated satellite data',
  pf: 'Forecast',
  cm: 'Cluster means',
  ep: 'Event probabilities',
  efi: 'Extreme forecast index',
  sot: 'Shift of tails',
  em: 'Ensemble means',
  es: 'Ensemble standard deviations',
  fcmean: 'Forecast mean'
}

const humanize = (type: string): string => {
  return SUBSET_TYPE_TO_NAME_MAP[type] ?? 'Other';
};

const SubsetTypes = {
  humanize
}

export default SubsetTypes;
